var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-dropdown',{staticClass:"is-flex",attrs:{"aria-role":"list","position":"is-bottom-left","trap-focus":""}},[_c('b-button',{staticClass:"is-reset link-more i-only is-muted vertical-center",attrs:{"slot":"trigger","role":"button"},slot:"trigger"}),_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }